import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

export const ActionsCellContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px;
  color: #3a84d8;
`;

export const RemoveIcon = styled(Glyphicon).attrs({
  glyph: 'trash',
})`
  cursor: pointer;
`;
